export default __webpack_public_path__ + "static/media/Hand_left.55fe3e9a.svg";